// import "@fortawesome/fontawesome-free/js/all";
import "bootstrap";
import 'regenerator-runtime/runtime'
import ExAstris from "./ExAstris";
import { gameData } from "./gameData";

let app = new ExAstris();
